import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BeePlugin from "@mailupinc/bee-plugin";
import { mapActions, mapGetters } from "vuex";
import { getBeePluginToken, getTemplateFromUrl } from "../marketing/api/templates-api";
import { CURRENT_USER_USERNAME } from "../main/store/account/account-getters";
import Err from "@Broker/@Routes/error";
import PageLoader from "@Shared/components/loaders/page-loader.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import SendTestEmailModal from "./html-template-editor/modals/send-test-email-modal.vue";
import { encode64 } from "@Broker/js/custom/utils";
import CreateEmailTemplateModal from "@Broker/@Modules/util-components/html-template-editor/modals/create-email-template-modal.vue";
import { CREATE_TEMPLATE } from "../marketing/store/templates/templates-actions";
import { showToast } from "@Shared/@Utils/constants";
import TemplateEditorHelpModal from "./html-template-editor/modals/template-editor-help-modal.vue";
import IncidentMessage from "../status-page/components/incident-message.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BeePluginContainer",
  components: {
    CreateEmailTemplateModal,
    PageLoader,
    SendTestEmailModal,
    TemplateEditorHelpModal,
    IncidentMessage
  },
  props: {
    containerId: {
      type: String,
      default: "bee-plugin-container"
    },
    previewTemplate: {
      type: Boolean,
      default: false
    },
    predefinedTemplate: {
      type: Boolean,
      default: false
    },
    saveOnLoad: {
      type: Boolean,
      default: true
    },
    beePluginConfig: {
      type: Object,
      default: () => ({})
    },
    templateId: {
      type: [String, Number],
      default: ""
    },
    templateName: {
      type: String,
      default: ""
    },
    templateSourceUrl: {
      type: String,
      default: ""
    },
    templateSourceJson: {
      type: String,
      default: ""
    },
    allowSaveAs: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showBeePlugin: false,
      beeInstance: null,
      pluginLoaded: false,
      currentBase64Email: "",
      currentTemplateJSON: "",
      createLoading: {
        loading: false,
        success: true
      },
      disableEditor: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_USERNAME])), {}, {
    beePluginLocale() {
      const localeMap = {
        "en-CA": "en-US",
        "fr-CA": "fr-FR"
      };
      return localeMap[this.$root.$i18n.locale];
    },
    beeConfig() {
      return _objectSpread({
        uid: this.CURRENT_USER_USERNAME,
        container: this.containerId,
        previewTemplate: this.previewTemplate,
        language: this.beePluginLocale,
        onSave: this.handleBeePluginSave,
        onSaveAsTemplate: this.handleBeePluginSaveAsTemplate,
        onError: this.handleBeePluginError,
        onLoad: this.handleBeePluginLoaded,
        onSend: this.handleBeePluginSend,
        onTogglePreview: this.handleBeeTogglePreview
      }, this.beePluginConfig);
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("TemplatesStore", [CREATE_TEMPLATE])), {}, {
    async getTemplateJSON() {
      return this.templateSourceJson || getTemplateFromUrl(this.templateSourceUrl);
    },
    async mountPlugin() {
      this.showBeePlugin = true;
      this.pluginLoaded = false;
      await this.$nextTick();
      const [token, templateJSON] = await _Promise.all([await getBeePluginToken(), await this.getTemplateJSON()]);
      this.beeInstance = new BeePlugin(token);
      await this.beeInstance.start(this.beeConfig, templateJSON);
    },
    reloadPlugin(templateJSON) {
      this.beeInstance.load(JSON.parse(templateJSON));
    },
    async unMountPlugin() {
      const confirmExit = await this.confirmExit();
      if (!confirmExit) return;
      this.showBeePlugin = false;
      await this.$nextTick();
      this.beeInstance = null;
      this.pluginLoaded = false;
      this.currentBase64Email = "";
      this.currentTemplateJSON = "";
      this.$emit("hidden");
    },
    handleBeePluginSave(jsonTemplate, htmlTemplate) {
      this.$emit("save", {
        jsonTemplate,
        htmlTemplate
      });
      Amplitude.logEvent("Templates - email template editor save triggered");
    },
    handleBeePluginSaveAsTemplate(jsonTemplate) {
      if (!this.allowSaveAs) {
        return showToast("info", "saveAsTemplateNotAllowed");
      }
      this.currentTemplateJSON = jsonTemplate;
      this.$refs.saveAsNewModal.$showModal();
      this.$emit("save-as-template", {
        jsonTemplate
      });
      Amplitude.logEvent("Templates - email template editor save as triggered");
    },
    handleBeePluginSend(htmlTemplate) {
      this.currentBase64Email = encode64(htmlTemplate);
      this.$nextTick(() => {
        this.$refs.sendTestEmailModal.showModal();
      });
      this.$emit("send", {
        htmlTemplate
      });
      Amplitude.logEvent("Templates - email template editor send triggered");
    },
    handleBeeTogglePreview(previewToggled) {
      this.$emit("preview", {
        previewToggled
      });
      Amplitude.logEvent("Templates - email template editor preview triggered", {
        previewToggled
      });
    },
    handleBeePluginError(errorMessage) {
      Err.handle(errorMessage);
      this.$emit("error", {
        error: errorMessage
      });
    },
    handleBeePluginLoaded() {
      if (this.saveOnLoad && !this.previewTemplate) {
        this.beeInstance.save();
      }
      if (this.previewTemplate) {
        Amplitude.logEvent("Templates - email preview loaded");
        this.beeInstance.preview();
      } else {
        Amplitude.logEvent("Templates - email editor loaded");
      }
      this.$emit("loaded");
      this.$nextTick(() => {
        this.pluginLoaded = true;
      });
    },
    handleManualSendTest() {
      this.beeInstance.send();
    },
    async confirmExit() {
      if (!this.showBeePlugin || this.previewTemplate) return true;
      return window.confirm(this.$t("templates.beePlugin.saveMessage"));
    },
    async handleCreateAs(templateName) {
      const newTemplateId = await this.createTemplate(templateName);
      if (!newTemplateId) return;
      this.reloadPlugin(this.currentTemplateJSON);
      this.$refs.saveAsNewModal.$hideModal();
      this.$emit("create-as", {
        templateName,
        templateId: newTemplateId,
        jsonTemplate: this.currentTemplateJSON
      });
      Amplitude.logEvent("Templates - email template editor new template created", {
        newTemplateId
      });
    },
    async createTemplate(templateName) {
      this.createLoading.loading = true;
      try {
        const templateId = await this.CREATE_TEMPLATE({
          name: templateName,
          selectedTemplateId: 0 //when doing a "save template as" we always duplicate the empty template (id 0)
        });
        this.createLoading.success = true;
        this.createLoading.loading = false;
        return templateId;
      } catch (error) {
        this.createLoading.success = false;
      } finally {
        this.createLoading.loading = false;
      }
    },
    handleOpenEditorHelp() {
      this.$refs.editorHelpModal.$showModal();
    },
    handleIncidentUpdate(hasIncident) {
      this.disableEditor = hasIncident;
    }
  })
});